import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import J2VAuth from "./libs/auth.js";

if (!J2VAuth.isSignedIn()) {
    console.log ("Credentials not validated", localStorage.getItem("userCredentials"));
    // window.location.href = "/login?redirect=/tools/visual-editor/";
}
else {
    console.log ("Credentials validated");
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
